import { useItemOutOfStockDate } from './hooks';

import makeClasses from './ItemOutOfStockDate.style';

export function ItemOutOfStockDate(props: Props) {
  const { shutdownDate, activationDate } = props;

  const { lang } = useItemOutOfStockDate();

  const _classes = makeClasses();

  return (
    <aside className={_classes.itemDatesAside}>
      <dl aria-label='shutdown-date'>
        <dt className={_classes.label}>{lang.shutdownDate.label}</dt>
        <dd className={_classes.date}>{shutdownDate ?? lang.indefinite}</dd>
      </dl>
      <dl aria-label='activation-date'>
        <dt className={_classes.label}>{lang.activationDate.label}</dt>
        <dd className={_classes.date}>{activationDate ?? lang.indefinite}</dd>
      </dl>
    </aside>
  );
}

interface Props {
  shutdownDate?: string | null;
  activationDate?: string | null;
}
